export const AuthCustomErrorMessage: ObjectType<string> = {
  PasswordComplexityRequirement: 'Your password must be stronger.'
};
